const getItemValues = (obj) => {
    let values = '';
    if (obj) {
        for (let i = 0; i < obj.length; i++) {
            if (i === 0) {
                values = obj[i].option ? obj[i].option : obj[i];
                continue;
            }
            const val = obj[i].option ? obj[i].option : obj[i];
            values += `, ${val}`;
        }
    }
    return values;
};
export default getItemValues;
